export default {
  pager: (state) => state.pager,
  measurement: (state) => state.measurement,
  measurements: (state) => state.measurements,
  photos: (state) => state.photos,
  vo2assessments: (state) => state.vo2assessments,
  vo2assessment: (state) => state.vo2assessment,
}
